import React from "react";
import {
    Box,
    Typography,
} from "@mui/material";

// Components
import LayoutCms from "@/theme/layout-cms";
import Icon from "@/theme/vectors/bundle";

// Hooks
import { useTranslation } from "@/hooks/useTranslation";

const AccessDenied = () => {
    const { t } = useTranslation();

    return (
        <LayoutCms>
            <Box sx={{ 
                display: 'flex', 
                flexDirection: 'column',
                justifyContent: 'center', 
                alignItems: 'center', 
                height: '80vh' 
            }}>
                <Icon name="lock" size={64} />
                <Typography variant="h5" sx={{ mt: 2, mb: 1, fontWeight: 'bold' }}>
                    {t('common.accessDenied')}
                </Typography>
                <Typography variant="body1" color="text.secondary">
                    {t('common.noPermission')}
                </Typography>
            </Box>
        </LayoutCms>
    );
};

export default AccessDenied;